/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { MotorCarrierUserInfoFragmentDoc } from './MotorCarrierUserInfoFragment'
import { MotorCarrierInfoFragmentDoc } from './MotorCarrierInfoFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IUsersMotorCarriersQueryVariables = Types.Exact<{ [key: string]: never }>

export type IUsersMotorCarriersQuery = { __typename?: 'Query' } & {
  motorCarrierUsersForUser: Array<
    { __typename?: 'MotorCarrierUser' } & Pick<Types.IMotorCarrierUser, 'id' | 'createdAt'> & {
        motorCarrier: { __typename?: 'MotorCarrier' } & Pick<
          Types.IMotorCarrier,
          | 'id'
          | 'legalName'
          | 'mcNumber'
          | 'dotNumber'
          | 'teamMemberCount'
          | 'state'
          | 'endorsements'
          | 'excludedCommodities'
        > & {
            equipmentCapability?: Types.Maybe<
              { __typename?: 'MotorCarrierEquipmentCapability' } & Pick<
                Types.IMotorCarrierEquipmentCapability,
                | 'id'
                | 'isDryVanCapable'
                | 'isFlatbedCapable'
                | 'isReeferCapable'
                | 'powerUnitCount'
                | 'trailerCount'
              >
            >
            freightCapability?: Types.Maybe<
              { __typename?: 'MotorCarrierFreightCapability' } & Pick<
                Types.IMotorCarrierFreightCapability,
                'id' | 'isDrayageCapable' | 'isFtlCapable' | 'isIntermodalCapable' | 'isLtlCapable'
              >
            >
            dedicatedLaneRatePreference?: Types.Maybe<
              { __typename?: 'MotorCarrierDedicatedLaneRatePreference' } & Pick<
                Types.IMotorCarrierDedicatedLaneRatePreference,
                'id' | 'isInterestedInDedicatedLanes' | 'minimumRatePerMile'
              >
            >
            loadingCapability?: Types.Maybe<
              { __typename?: 'MotorCarrierLoadingCapability' } & Pick<
                Types.IMotorCarrierLoadingCapability,
                'id' | 'isHeavyLoadCapable' | 'isDropCapable' | 'isLiveCapable' | 'isPowerOnly'
              >
            >
            rateTypePreference?: Types.Maybe<
              { __typename?: 'MotorCarrierRateTypePreference' } & Pick<
                Types.IMotorCarrierRateTypePreference,
                'id' | 'allowsDayRate' | 'allowsAllIn' | 'hasLineHaulFuelSurcharge'
              >
            >
            certifications: Array<
              { __typename?: 'MotorCarrierCertification' } & Pick<
                Types.IMotorCarrierCertification,
                'id' | 'code' | 'issuingOrganization' | 'isVerified' | 'renewalDate'
              >
            >
            smartWayRegistration?: Types.Maybe<
              { __typename?: 'MotorCarrierSmartWayRegistration' } & Pick<
                Types.IMotorCarrierSmartWayRegistration,
                'id' | 'isRegistered' | 'renewalDate'
              >
            >
          }
      }
  >
  motorCarrierJoinRequestsForUser?: Types.Maybe<
    Array<
      { __typename?: 'MotorCarrierJoinRequest' } & Pick<
        Types.IMotorCarrierJoinRequest,
        'id' | 'approvedAt'
      > & {
          motorCarrier: { __typename?: 'MotorCarrier' } & Pick<
            Types.IMotorCarrier,
            | 'id'
            | 'legalName'
            | 'mcNumber'
            | 'dotNumber'
            | 'teamMemberCount'
            | 'state'
            | 'endorsements'
            | 'excludedCommodities'
          > & {
              equipmentCapability?: Types.Maybe<
                { __typename?: 'MotorCarrierEquipmentCapability' } & Pick<
                  Types.IMotorCarrierEquipmentCapability,
                  | 'id'
                  | 'isDryVanCapable'
                  | 'isFlatbedCapable'
                  | 'isReeferCapable'
                  | 'powerUnitCount'
                  | 'trailerCount'
                >
              >
              freightCapability?: Types.Maybe<
                { __typename?: 'MotorCarrierFreightCapability' } & Pick<
                  Types.IMotorCarrierFreightCapability,
                  | 'id'
                  | 'isDrayageCapable'
                  | 'isFtlCapable'
                  | 'isIntermodalCapable'
                  | 'isLtlCapable'
                >
              >
              dedicatedLaneRatePreference?: Types.Maybe<
                { __typename?: 'MotorCarrierDedicatedLaneRatePreference' } & Pick<
                  Types.IMotorCarrierDedicatedLaneRatePreference,
                  'id' | 'isInterestedInDedicatedLanes' | 'minimumRatePerMile'
                >
              >
              loadingCapability?: Types.Maybe<
                { __typename?: 'MotorCarrierLoadingCapability' } & Pick<
                  Types.IMotorCarrierLoadingCapability,
                  'id' | 'isHeavyLoadCapable' | 'isDropCapable' | 'isLiveCapable' | 'isPowerOnly'
                >
              >
              rateTypePreference?: Types.Maybe<
                { __typename?: 'MotorCarrierRateTypePreference' } & Pick<
                  Types.IMotorCarrierRateTypePreference,
                  'id' | 'allowsDayRate' | 'allowsAllIn' | 'hasLineHaulFuelSurcharge'
                >
              >
              certifications: Array<
                { __typename?: 'MotorCarrierCertification' } & Pick<
                  Types.IMotorCarrierCertification,
                  'id' | 'code' | 'issuingOrganization' | 'isVerified' | 'renewalDate'
                >
              >
              smartWayRegistration?: Types.Maybe<
                { __typename?: 'MotorCarrierSmartWayRegistration' } & Pick<
                  Types.IMotorCarrierSmartWayRegistration,
                  'id' | 'isRegistered' | 'renewalDate'
                >
              >
            }
        }
    >
  >
}

export const UsersMotorCarriersDocument = gql`
  query UsersMotorCarriers {
    motorCarrierUsersForUser {
      ...MotorCarrierUserInfo
    }
    motorCarrierJoinRequestsForUser {
      id
      approvedAt
      motorCarrier {
        ...MotorCarrierInfo
      }
    }
  }
  ${MotorCarrierUserInfoFragmentDoc}
  ${MotorCarrierInfoFragmentDoc}
`

/**
 * __useUsersMotorCarriersQuery__
 *
 * To run a query within a React component, call `useUsersMotorCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersMotorCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersMotorCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsersMotorCarriersQuery(
  baseOptions?: Apollo.QueryHookOptions<IUsersMotorCarriersQuery, IUsersMotorCarriersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUsersMotorCarriersQuery, IUsersMotorCarriersQueryVariables>(
    UsersMotorCarriersDocument,
    options
  )
}
export function useUsersMotorCarriersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IUsersMotorCarriersQuery,
    IUsersMotorCarriersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUsersMotorCarriersQuery, IUsersMotorCarriersQueryVariables>(
    UsersMotorCarriersDocument,
    options
  )
}
export type UsersMotorCarriersQueryHookResult = ReturnType<typeof useUsersMotorCarriersQuery>
export type UsersMotorCarriersLazyQueryHookResult = ReturnType<
  typeof useUsersMotorCarriersLazyQuery
>
export type UsersMotorCarriersQueryResult = Apollo.QueryResult<
  IUsersMotorCarriersQuery,
  IUsersMotorCarriersQueryVariables
>
